/*
  Opens Judge.me's "Write a review" form when a product page is opened with #write-review
  (used by the setup guide's "Share your setup" cards). Falls back to scrolling to the review widget.
*/
(function () {
  'use strict';
  if (window.__mlReviewOpen) return;
  window.__mlReviewOpen = true;
  if (location.hash !== '#write-review') return;

  var tries = 0;
  var MAX_TRIES = 48; // ~12 seconds while Judge.me loads
  function widget() {
    return document.getElementById('judgeme_product_reviews') ||
      document.querySelector('.jdgm-review-widget, .jdgm-rev-widg, .jdgm-widget');
  }
  function formOpen() {
    var f = document.querySelector('.jdgm-form-wrapper, .jdgm-form');
    return f && f.offsetParent !== null ? f : null;
  }
  function tick() {
    tries++;
    var w = widget();
    var btn = document.querySelector('.jdgm-write-rev-link, [data-jdgm-write-review]');
    if (btn) {
      if (!formOpen()) btn.click();
      setTimeout(function () {
        var target = formOpen() || w || btn;
        target.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }, 350);
      return;
    }
    if (tries < MAX_TRIES) { setTimeout(tick, 250); return; }
    if (w) w.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
  if (document.readyState === 'complete') tick();
  else window.addEventListener('load', tick);
})();
